const doc = [({"ko":({"adminConstantHotelOptionPriceType":({"fixed":"고정 요금", "percent":"성인 요금의 비율"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;